export const isSttPanelBlocked = (el: Element | null) => {
  return !!el?.closest('[data-block-stt-panel]')
}
